import { parse } from '../../util/urlHelpers';

import axios from 'axios';
import { apiBaseUrl } from '../../util/api';
import { fetchCurrentUser, fetchCurrentWorkerUserExtraDetails } from '../../ducks/user.duck';
import { denormalisedResponseEntities } from '../../util/data';
import * as log from '../../util/log';
import {
  TRANSITION_BLOCK_BY_BUSINESS,
  TRANSITION_STARTING_JOB,
  pastShiftTransitions,
} from '../../util/transaction';
import { fetchWorkingStaffShifts } from '../WorkerDashboardPage/WorkerDashboardPage.duck';
import { isEmpty } from 'lodash';

const RESULT_PAGE_SIZE = 18;

// ================ Action types ================ //

export const FETCH_WORKERS_DATA_REQUEST =
  'app/WorkerProfileAdminViewPage/FETCH_WORKERS_DATA_REQUEST';
export const FETCH_WORKERS_DATA_SUCCESS =
  'app/WorkerProfileAdminViewPage/FETCH_WORKERS_DATA_SUCCESS';
export const FETCH_WORKERS_DATA_ERROR = 'app/WorkerProfileAdminViewPage/FETCH_WORKERS_DATA_ERROR';
export const FETCH_IS_BLOCKED_WORKER = 'app/WorkerProfileAdminViewPage/FETCH_IS_BLOCKED_WORKER';
export const FETCH_BLOCKER_ID = 'app/WorkerProfileAdminViewPage/FETCH_BLOCKER_ID';
export const FETCH_BLOCKER_ID_REQUEST = 'app/WorkerProfileAdminViewPage/FETCH_BLOCKER_ID_REQUEST';

export const VERIFY_WORKERS_DATA_REQUEST =
  'app/WorkerProfileAdminViewPage/VERIFY_WORKERS_DATA_REQUEST';
export const VERIFY_WORKERS_DATA_SUCCESS =
  'app/WorkerProfileAdminViewPage/VERIFY_WORKERS_DATA_SUCCESS';
export const VERIFY_WORKERS_DATA_ERROR = 'app/WorkerProfileAdminViewPage/VERIFY_WORKERS_DATA_ERROR';
export const SHIFT_WORKED = 'app/WorkerProfileAdminViewPage/SHIFT_WORKED';
// ================ Reducer ================ //

const initialState = {
  fetchInProgress: false,
  fetchWorkersDataError: null,
  pagination: null,
  currentStaffData: {},
  staffDataRequest: false,
  isWorkerBlocked: null,
  verifyRequest: false,
  blockerData: [],
  blockedData: [],
  shiftWorked: null,
};

export default function AdminStaffProfileViewPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  // console.log(333, payload);
  switch (type) {
    case FETCH_WORKERS_DATA_REQUEST:
      return {
        ...state,
        staffDataRequest: true,
        fetchWorkersDataError: null,
        currentStaffData: [],
      };
    case FETCH_WORKERS_DATA_SUCCESS: {
      return {
        ...state,
        staffDataRequest: false,
        currentStaffData: payload,

        // pagination: payload.data.meta,
      };
    }
    case FETCH_WORKERS_DATA_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, staffDataRequest: false, fetchWorkersDataError: payload };
    case FETCH_IS_BLOCKED_WORKER: {
      // console.log(777,payload)
      return {
        ...state,
        // fetchInProgress: false,
        blockedData: payload,
      };
    }
    case VERIFY_WORKERS_DATA_REQUEST:
      return {
        ...state,
        verifyRequest: true,
        fetchWorkersDataError: null,
        currentStaffData: [],
      };
    case VERIFY_WORKERS_DATA_SUCCESS: {
      return {
        ...state,
        verifyRequest: false,
        currentStaffData: payload,

        // pagination: payload.data.meta,
      };
    }
    case VERIFY_WORKERS_DATA_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, verifyRequest: false, fetchWorkersDataError: payload };
    case FETCH_BLOCKER_ID_REQUEST:
      return {
        ...state,
        fetchInProgress: true,
        // fetchWorkersDataError: null,
        blockerData: [],
      };
    case FETCH_BLOCKER_ID: {
      return {
        ...state,
        fetchInProgress: false,
        blockerData: payload,
      };
    }
    case SHIFT_WORKED: {
      return {
        ...state,
        shiftWorked: payload,
      };
    }
    default:
      return state;
  }
}
// ================ Action creators ================ //

const fetchWorkersDataRequest = () => ({ type: FETCH_WORKERS_DATA_REQUEST });
const fetchWorkersDataSuccess = response => ({
  type: FETCH_WORKERS_DATA_SUCCESS,
  payload: response,
});
const fetchWorkersDataError = e => ({
  type: FETCH_WORKERS_DATA_ERROR,
  error: true,
  payload: e,
});
const fetchIsBlockedWorker = res => ({
  type: FETCH_IS_BLOCKED_WORKER,
  payload: res,
});
const fetchBlockerIdRequest = () => ({ type: FETCH_BLOCKER_ID_REQUEST });

const fetchBlockerId = res => ({
  type: FETCH_BLOCKER_ID,
  payload: res,
});
const fetchShiftWorked = res => ({
  type: SHIFT_WORKED,
  payload: res,
});

// ================ Thunks ================ //
export const fetchWorkersData = param => async (dispatch, getState, sdk) => {
  const userId = param.id;

  await dispatch(fetchCurrentUser());
  const fetchedcurrentUser = getState().user.currentUser;
  const authorId = fetchedcurrentUser?.id?.uuid;

  let apiCurrentUser;
  dispatch(fetchWorkersDataRequest());

  return (
    axios
      .get(`${apiBaseUrl()}/api/user/admin/staffData?userId=${userId}`, {
        withCredentials: true,
      })
      .then(response => {
        // console.log(111, response.data);
        // dispatch(fetchWorkersDataSuccess(response));

        apiCurrentUser = response.data;
        // console.log(123, apiCurrentUser);
      })
      .then(_ => {
        if (!apiCurrentUser.data.attributes.profile.publicData.isProvider) {
          return dispatch(fetchCurrentWorkerUserExtraDetails(apiCurrentUser.data.id.uuid));
        }
        return null;
      })
      .then(resp => {
        // console.log(369, resp);
        if (resp !== null && typeof resp === 'object') {
          // console.log(444, apiCurrentUser);
          // apiCurrentUser.attributes.profile.publicData = {
          //   ...apiCurrentUser.attributes.profile.publicData,
          //   resp,
          // };
          Object.assign(apiCurrentUser.data.attributes.profile.publicData, resp);
        }
        // console.log(585, apiCurrentUser);

        dispatch(fetchWorkersDataSuccess(apiCurrentUser));
      })
      .then(() => {
        const isSuperAdmin = fetchedcurrentUser?.attributes?.profile?.publicData?.isSuperAdmin;
        // console.log(6667, isSuperAdmin);
        if (isSuperAdmin) {
          axios
            .get(`${apiBaseUrl()}/api/user/blockedbybusinesses/${userId}`, {
              withCredentials: true,
            })
            .then(res => {
              const blockerIds = res?.data?.map(m => m?.blockerId);
              // console.log(222, blockerIds, res.data);
              const respData = Promise.all(
                blockerIds.map(m =>
                  sdk.users.show({
                    id: m,
                    include: ['profileImage'],
                    'fields.image': [
                      'variants.default',
                      'variants.square-small',
                      'variants.square-small2x',
                    ],
                  })
                )
              );
              respData.then(res => {
                // console.log(3456, res);

                const data = res.map(m => m.data);
                return dispatch(fetchBlockerId(data));
              });
            })
            .then(() => {
              return axios.post(`${apiBaseUrl()}/api/workerTransactionForBusiness`, {
                customerId: userId,
                // providerId: businessId,
              });
            })
            .then(res => {
              const pastgigInfo = res?.data?.data?.data?.filter(m =>
                pastShiftTransitions?.includes(m?.attributes?.lastTransition)
              );
              // console.log(
              //   666,
              //   res,
              //   res?.data?.data?.data?.filter(m =>
              //     pastShiftTransitions?.includes(m?.attributes?.lastTransition)
              //   ),
              //   pastgigInfo.length
              // );
              dispatch(fetchShiftWorked(pastgigInfo.length));
            });
        } else {
          const resp = axios.get(
            `${apiBaseUrl()}/api/user/isWorkerBlockedbyAuthor/${authorId}/${userId}`,
            {
              withCredentials: true,
            }
          );
          resp
            .then(res => {
              // console.log(455,res.data)
              return dispatch(fetchIsBlockedWorker(res.data));
            })
            .then(() => {
              return dispatch(fetchWorkingStaffShifts({ tab: 'pastShifts', workerId: userId }));
            })
            .then(res => {
              // console.log(333, res);
              dispatch(fetchShiftWorked(res?.data?.meta?.totalItems));
            });
        }
      })

      //super aadmin
      // .then(() => {
      //   axios
      //     .get(`${apiBaseUrl()}/api/user/blockedbybusinesses/${userId}`, {
      //       withCredentials: true,
      //     })
      //     .then(res => {
      //       const blockerIds = res?.data?.map(m => m?.blockerId);
      //       const respData = Promise.all(
      //         blockerIds.map(m =>
      //           sdk.users.show({
      //             id: m,
      //             include: ['profileImage'],
      //             'fields.image': [
      //               'variants.default',
      //               'variants.square-small',
      //               'variants.square-small2x',
      //             ],
      //           })
      //         )
      //       );
      //       respData.then(res => {
      //         // console.log(3456, res);

      //         const data = res.map(m => m.data);
      //         return dispatch(fetchBlockerId(data));
      //       });
      //     });
      // })
      .catch(error => {
        dispatch(fetchWorkersDataError(error));
      })
  );
};
export const verifyWorkersCategory = param => async (dispatch, getState, sdk) => {
  const { categoryId, userId } = param;
  // console.log(147, ' VerifyWorkerData called', categoryId, userId);
  let apiResponse;
  return axios
    .get(`${apiBaseUrl()}/api/user/admin/verifyWorkerCategory?categoryId=${categoryId}`, {
      withCredentials: true,
    })
    .then(response => {
      apiResponse = response;
      const mailUrl = `${apiBaseUrl()}/api/crm-mails/worker/category-verified/${userId}`;
      // console.log(111, response);
      // dispatch(fetchWorkersData({ id: userId }));
      return axios.get(mailUrl);
    })
    .then(() => {
      return apiResponse;
    })
    .catch(error => {
      // console.log(error);
      dispatch(fetchWorkersDataError(error));
    });
};
export const verifyWorkersReference = param => async (dispatch, getState, sdk) => {
  const { referenceId, userId } = param;
  // console.log(147, ' VerifyWorkerData called', referenceId, userId);
  let apiResponse;
  return axios
    .get(`${apiBaseUrl()}/api/user/admin/verifyWorkerReference?referenceId=${referenceId}`, {
      withCredentials: true,
    })
    .then(response => {
      apiResponse = response;
      const mailUrl = `${apiBaseUrl()}/api/crm-mails/worker/something-verified/${userId}`;
      // console.log(111, response);
      // dispatch(fetchWorkersData({ id: userId }));
      return axios.get(mailUrl);
    })
    .then(() => {
      return apiResponse;
    })
    .then(response => {
      // console.log(111, response);
      return dispatch(fetchWorkersData({ id: userId }));
    })
    .catch(error => {
      // console.log(error);
      dispatch(fetchWorkersDataError(error));
    });
};
export const blockUser = param => async (dispatch, getState, sdk) => {
  // console.log(888, param);
  const {
    currentUserID,
    userId,
    msg,
    blockerCompanyName,
    blockerBusinessId,
    blockerName,
    workerName,
    workerId,
  } = param;
  await dispatch(fetchCurrentUser());
  const fetchedcurrentUser = getState().user.currentUser;
  const authorId = fetchedcurrentUser.id.uuid;
  const body = {
    blockerId: currentUserID,
    blockedWorkerId: userId,
    shouldNotifyBlockedUser: true,
    shouldNotifyAdmin: true,
    BlockedReason: msg,
    blockCheckbox: true,
    blockerCompanyName,
    blockerBusinessId,
    blockerName,
    workerName,
    workerId,
  };
  return axios
    .post(`${apiBaseUrl()}/api/user/updateBlockedUserDb`, { body }, { withCredentials: true })
    .then(res => {
      // console.log(23333, res);
      const isBlockedWorker = {
        block: true,
        blockReason: [res?.data?.BlockedReason],
      };
      const unBlockedWorker = {
        block: false,
        blockReason: [],
      };
      dispatch(
        fetchIsBlockedWorker(res?.data?.BlockedReason ? [isBlockedWorker] : [unBlockedWorker])
      );
      return res;
      // const resp = axios.get(
      //   `${apiBaseUrl()}/api/user/isWorkerBlockedbyAuthor/${authorId}/${userId}`,
      //   {
      //     withCredentials: true,
      //   }
      // );
      // resp.then(res => {
      //   return dispatch(fetchIsBlockedWorker(res.data));
      // });
    })
    .then(res => {
      if (Object.keys(res?.data || {}).length === 0) {
        return { data: { data: [] } };
      }
      const txsToBlock = sdk.transactions.query({
        only: 'sale',
        userId,
        lastTransitions: [TRANSITION_STARTING_JOB],
      });
      return txsToBlock;
    })
    .then(res => {
      if (res.data.data?.length > 0) {
        const txs = res.data.data;
        const promises = txs.map(tx =>
          sdk.transactions.transition({
            id: tx.id.uuid,
            transition: TRANSITION_BLOCK_BY_BUSINESS,
            params: {},
          })
        );
        return Promise.all(promises);
      } else {
        return res;
      }
    })
    .then(async res => {
      const hasRequireData = workerId && blockerCompanyName && msg;
      if (!hasRequireData) {
        return res;
      }
      const mailData = { workerId, business: blockerCompanyName, reason: msg };
      if (isEmpty(mailData) || !(mailData.workerId && mailData.business && mailData.reason)) {
        return res;
      }
      const mailUrl = `${apiBaseUrl()}/api/mail/blocked`;
      await axios.post(mailUrl);
      return res;
    });
};
const blockBusinessWorker = (searchItem, id) => async (dispatch, getState, sdk) => {
  dispatch(fetchBlockerIdRequest());
  // console.log(333,searchItem)
  axios
    .post(`${apiBaseUrl()}/api/user/searchBusiness`, {
      searchItem,
      id,
    })
    .then(res => {
      // console.log(999,res)
      const blockerIds = res?.data?.map(m => m?.blockerId);
      const respData = Promise.all(
        blockerIds.map(m =>
          sdk.users.show({
            id: m,
            include: ['profileImage'],
            'fields.image': [
              'variants.default',
              'variants.square-small',
              'variants.square-small2x',
            ],
          })
        )
      );
      respData.then(res => {
        const data = res.map(m => m.data);
        return dispatch(fetchBlockerId(data));
      });
    })
    .catch(err => {
      console.log(err);
    });
};

export const loadData = (params, search) => (dispatch, getState, sdk) => {
  const queryParams = parse(search);
  const queryPage = queryParams.page || 1;
  const slug = params.slug;
  const { blockBusinessSearch, searchItem } = queryParams;
  const { id } = params;
  if (blockBusinessSearch === true) {
    return dispatch(blockBusinessWorker(searchItem, id));
  }
  return dispatch(fetchWorkersData(params));
};
